import Reveal from '@/components/base/Reveal';
import SectionTitle from '@/components/base/SectionTitle';

const quickFacts = [
  { id: 'q1', icon: 'ri-user-heart-line', title: '核心关系', text: '姐夫、姐姐与小姨子三人在同一屋檐下的磨合，是全剧的情感主轴。' },
  { id: 'q2', icon: 'ri-flashlight-line', title: '叙事节奏', text: '单集 2–4 分钟，几乎每集结尾都留一个钩子，适合连续追看。' },
  { id: 'q3', icon: 'ri-emotion-happy-line', title: '情绪配方', text: '前期轻松日常，中段误会集中爆发，后期以和解与成长收束。' },
  { id: 'q4', icon: 'ri-search-eye-line', title: '观看重点', text: '留意反复出现的旧物与台词，许多反转都提前埋在同一天的细节里。' },
];

export default function IntroSection() {
  return (
    <section id="intro" className="bg-background-50 py-14 md:py-20">
      <div className="mx-auto px-4 md:px-6 max-w-7xl">
        <Reveal>
          <SectionTitle
            eyebrow="剧情速览"
            title="先花三分钟，看懂《漂亮的小姨子》在讲什么"
            description="如果只是被剧名吸引点进来，这一区会帮你快速建立认知：故事从哪里开始、冲突为什么发生、最终又走向怎样的收束。看完再决定是逐集细品，还是一口气看到大结局。"
          />
        </Reveal>

        <div className="mt-10 grid gap-6 md:gap-8 grid-cols-1 lg:grid-cols-12">
          <Reveal className="lg:col-span-7" delay={60}>
            <article className="h-full rounded-lg border border-background-200 bg-background-100 p-5 md:p-7">
              <h3 className="font-heading text-lg md:text-xl font-bold text-foreground-950">一个屋檐，三种立场</h3>
              <div className="mt-4 space-y-4 font-body text-sm md:text-base leading-relaxed text-foreground-700">
                <p>
                  故事从苏念临时搬进姐姐家开始。她刚毕业、说话直接，而姐夫陆承习惯把情绪收起来。两个人对“家人该有怎样的边界”理解完全不同，第一顿晚饭就吃得各怀心事。观众看到的不是脸谱化的对错，而是三个人各自合理、却彼此错位的选择。
                </p>
                <p>
                  中段开始，一位旧识周彦的重新出现，让原本平稳的关系被一点点撬动。一条被断章取义的视频、一桩多年前的旧账，把误会推到顶点；而姐姐苏晚隐瞒已久的病情，则让此前所有看似琐碎的日常细节，都有了另一种解释。
                </p>
                <p>
                  到了结尾，剧集没有停在“谁对谁错”的判定上，而是把镜头交还给日常：同一张餐桌、同样三个人，这一次他们终于把该说的话说出口。《漂亮的小姨子》想讲的，其实是关系如何从戒备走到理解。
                </p>
              </div>
              <blockquote className="mt-6 border-l-2 border-primary-400 pl-4 font-heading text-sm md:text-base italic text-foreground-800">
                “有些话说晚了，就变成了解释；有些人等久了，就成了家人。”——剧中反复被提起的一句台词
              </blockquote>
            </article>
          </Reveal>

          <div className="lg:col-span-5 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-1 gap-4">
            {quickFacts.map((fact, index) => (
              <Reveal key={fact.id} delay={120 + index * 60}>
                <div className="h-full rounded-lg border border-background-200 bg-background-100 p-5 flex items-start gap-4">
                  <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-md bg-accent-100 text-accent-800">
                    <i className={`${fact.icon} text-xl`} aria-hidden="true" />
                  </span>
                  <div>
                    <h3 className="font-heading text-base font-bold text-foreground-950">{fact.title}</h3>
                    <p className="mt-1 font-body text-sm leading-relaxed text-foreground-700">{fact.text}</p>
                  </div>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}